var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"onboarding"},[_c('div',{staticClass:"af-header"},[_c('img',{staticClass:"instacash-logo",attrs:{"src":require('@/assets/images/instacash-logo-black.svg'),"alt":"InstaCash logo"}})]),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }